import React from 'react'
import UsersTable from '../../components/AdminPageComponents/UsersTable'
import Base from '../Base'

const Users = () => {
    return (
        <Base>
        <UsersTable/>
        </Base>
    )
}

export default Users
